import AuthNamespace from 'firebase/auth';
import React, { Dispatch, SetStateAction } from 'react';
import { PropsWithChildrenOnly } from 'types/react';
import { useAuthService } from '../hooks/useAuthService';
import { IAuthService } from '../services/auth/interface';
import { auth } from '../services/firebase/config';

export type IdpUser = AuthNamespace.User | null;
export interface ContextState extends IAuthService {
    idpUser: IdpUser;
    verificationSent: boolean;
    setVerificationSent: Dispatch<SetStateAction<boolean>>;
}

const AuthContext = React.createContext<ContextState | undefined>(undefined);
export const AuthProvider: React.FC<PropsWithChildrenOnly> = ({ children }) => {
    const [idpUser, setIdpUser] = React.useState<IdpUser>(null);
    const [verificationSent, setVerificationSent] = React.useState<boolean>(false);

    const authService = useAuthService();

    const value = {
        idpUser: idpUser,
        verificationSent,
        setVerificationSent,
        loginInWithEmailAndPassword: authService.loginInWithEmailAndPassword,
        loginThroughGoogle: authService.loginThroughGoogle,
        loginThroughMicrosoft: authService.loginThroughMicrosoft,
        loginThroughApple: authService.loginThroughApple,
        registerWithEmailAndPassword: authService.registerWithEmailAndPassword,
        signUpWithGoogle: authService.signUpWithGoogle,
        signUpWithMicrosoft: authService.signUpWithMicrosoft,
        signUpWithApple: authService.signUpWithApple,
        logout: authService.logout,
        resetPassword: authService.resetPassword,
        handleRedirect: authService.handleRedirect,
    };

    React.useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(setIdpUser);
        return () => {
            unsubscribe();
        };
    }, []);
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export function useAuthValue() {
    return React.useContext(AuthContext);
}
